export const GROUP_CONSTANTS = {
  ACTIVE_STATUS: 'ACTIVE',
  INACTIVE_STATUS: 'INACTIVE',

  CHOOSE_DAYS_OFF: 'CHOOSE_DAYS_OFF',
  SHIFT_WINDOW: 'SHIFT_WINDOW',
  TAKE_LEAVE_ON_GROUP: 'TAKE_LEAVE_ON_GROUP',

  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_HEAD: 'ROLE_HEAD',
  ROLE_USER: 'ROLE_USER',

  HEAD_POSITION: 'Head',
  DEPUTY_POSITION: 'Deputy',

  SORT_BY_LAST_NAME: 'LAST_NAME',
  SORT_BY_FULL_NATIVE_NAME: 'FULL_NATIVE_NAME',
  SORT_BY_SKILLS: 'SKILLS',
  SORT_BY_LOYALTY: 'LOYALTY',
  SORT_BY_GRAVITY: 'GRAVITY',
  SORT_BY_INTEGRATION: 'INTEGRATION',
  SORT_BY_SPEED: 'SPEED',

  SORT_ASC: 'ASC',
  SORT_DESC: 'DESC'
};

export enum HttpStatus {
  NETWORK_ERROR = 0,
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  ALREADY_REPORTED = 208,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  NOT_ACCEPTABLE = 406,
  CONFLICT = 409,
  GONE = 410,
  LENGTH_REQUIRED = 411,
  PRECONDITION_FAILED = 412,
  REQUEST_ENTITY_TOO_LARGE = 413,
  REQUEST_URI_TOO_LONG = 414,
  UNSUPPORTED_MEDIA_TYPE = 415,
  REQUESTED_RANGE_NOT_SATISFIABLE = 416,
  EXPECTATION_FAILED = 417,
  IM_A_TEAPOT = 418,
  UNPROCESSABLE_ENTITY = 422,
  LOCKED = 423,
  FAILED_DEPENDENCY = 424,
  PRECONDITION_REQUIRED = 428,
  TOO_MANY_REQUESTS = 429,
  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504
}

export const HTTP_STATUS_CODES = HttpStatus;

export const TIMEOUT_VALUES = {
  SHORT_DELAY: 100,
  DEFAULT_DELAY: 2000,
  LONG_DELAY: 3000
};

export const DEFAULT_VALUES = {
  NA_STRING: 'N/A',
  NOREP_FLAG: 'norep',
  NULL_VALUE: null
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/shared.constants/all-constants.ts